"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.searchWithIonizations = searchWithIonizations;
const chemical_elements_1 = require("chemical-elements");
const mf_parser_1 = require("mf-parser");
const mf_utilities_1 = require("mf-utilities");
const fetchJSON_js_1 = require("./fetchJSON.js");
const getAllowedEMs_js_1 = require("./getAllowedEMs.js");
const parseMasses_js_1 = require("./parseMasses.js");
async function searchWithIonizations(options) {
    const { realURL, fields, precision = 100, limit = 1000, searchParams = {}, ranges, } = options;
    searchParams.precision = String(precision);
    searchParams.limit = String(limit);
    if (fields)
        searchParams.fields = fields;
    let ionizations = (0, mf_utilities_1.preprocessIonizations)(options.ionizations);
    const masses = (0, parseMasses_js_1.parseMasses)(options.masses || [0]);
    // if we have ranges we need to filter the allowed EMs
    const allowedEMs = await (0, getAllowedEMs_js_1.getAllowedEMs)({
        ranges,
        masses,
        precision,
        ionizations,
    });
    const promises = [];
    for (let ionization of ionizations) {
        for (let mass of masses) {
            if (mass !== 0) {
                const realMass = mass * Math.abs(ionization.charge || 1) -
                    ionization.em +
                    chemical_elements_1.ELECTRON_MASS * ionization.charge;
                searchParams.em = String(realMass);
            }
            promises.push((0, fetchJSON_js_1.fetchJSON)(realURL, searchParams));
        }
    }
    const results = await Promise.all(promises);
    const entries = [];
    let counter = 0;
    for (const result of results) {
        const ionization = ionizations[Math.floor(counter / masses.length)];
        const targetMass = masses[counter % masses.length];
        counter++;
        for (const entry of result.data) {
            if (allowedEMs &&
                !allowedEMs.some((em) => Math.abs(em - entry.data.em) < 0.0000001)) {
                continue;
            }
            try {
                entry.mfInfo = new mf_parser_1.MF(entry.data?.mf || entry._id).getInfo({
                    emFieldName: 'em',
                    msemFieldName: 'msem',
                });
                entry.ionization = ionization;
                entry.ms = (0, mf_utilities_1.getMsInfo)(entry.mfInfo, {
                    targetMass,
                    ionization,
                }).ms;
                entries.push(entry);
            }
            catch (error) {
                // eslint-disable-next-line no-console
                console.warn(`${error}`);
            }
        }
    }
    if (entries.length > limit) {
        entries.length = limit;
    }
    return entries;
}
//# sourceMappingURL=searchWithIonizations.js.map